import { BoxProps } from '@jfs/ui-new'
import { ViewStyle } from 'react-native'

export const styles = {
  container: {
    shadowOffset: { width: 0, height: 2 },
    shadowRadius: 3,
    // Todo
    shadowColor: 'GREY_MATTE',
    zIndex: 4,
    // Todo
    backgroundColor: 'WHITE',
    margin: 16,
    borderBottomWidth: 1,
    // Todo
    borderBottomColor: 'DISABLED_GREY',
    justifyContent: 'space-between',
    borderRadius: 4,
    f: 1,
  } as BoxProps,
  innerContainer: {
    borderWidth: 1,
    // Todo
    borderColor: '#E1E5E8',
    paddingVertical: 20,
    paddingTop: 0,
  } as ViewStyle,
  header: {
    display: 'flex',
    padding: 16,
    flexDirection: 'column',
    marginHorizontal: 0,
    alignItems: 'flex-start',
  } as BoxProps,
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    margin: 16,
  } as BoxProps,
  tableContainer: {
    height: 148,
    // borderWidth: 1,
    // Todo
    // borderColor: '#E1E5E8',
    // borderRadius: 4,
  },
  emptyContainer: {
    borderWidth: 1,
    // Todo
    borderColor: '#E1E5E8',
    borderRadius: 4,
    flex: 1,
  },
  rowLayout: {
    display: 'flex',
    flexDirection: 'row',
  },
}
